function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Twitter");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M15,0C6.7,0,0,6.7,0,15s6.7,15,15,15s15-6.7,15-15S23.3,0,15,0z M23,11.5c0,0.2,0,0.3,0,0.5 c0,5.6-4.4,10.2-10,10.2c-0.1,0-0.1,0-0.2,0c-2,0-3.9-0.6-5.5-1.6c0.3,0,0.6,0.1,0.9,0.1c1.6,0,3.2-0.5,4.5-1.5 c-1.5,0-2.9-1-3.3-2.5c0.2,0,0.4,0.1,0.7,0.1c0.3,0,0.6,0,0.9-0.1c-1.7-0.3-2.9-1.8-2.9-3.5c0.5,0.3,1.1,0.4,1.6,0.4 c-1.6-1-2.1-3.1-1.1-4.8c1.8,2.2,4.5,3.6,7.4,3.7c-0.1-0.3-0.1-0.5-0.1-0.8c0-2,1.5-3.6,3.5-3.7c1,0,2,0.4,2.7,1.2 c0.8-0.2,1.6-0.4,2.3-0.9c-0.3,0.8-0.8,1.5-1.6,2c0.7-0.1,1.4-0.3,2-0.6C24.3,10.4,23.7,11,23,11.5z"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.d06dfd0a.svg";
export { ForwardRef as ReactComponent };